import { defineType } from 'sanity'
import getPageInfo, { seoGroup } from '../objects/pageInfo'

export default defineType({
  name: 'articleCategory',
  title: 'Category',
  type: 'document',
  orderings: [
    {
      title: 'Title A-Z',
      name: 'titleAsc',
      by: [{field: 'pageInfo.title', direction: 'asc'}],
    },
  ],
  groups: [
    {
      name: 'content',
      title: 'Content',
      default: true,
    },
    seoGroup,
  ],
  fields: [getPageInfo({ path: 'articleCategory' })],
  preview: {
    select: {
      name: 'pageInfo.title',
    },
    prepare({ name: title = 'New Category' }) {
      return { title }
    },
  },
})